import { jsx as _jsx } from "react/jsx-runtime";
import { useWidgetRegister } from '_widgetRegister';
import * as React from 'react';
import { EMPTY_WIDGET_PLACEMENT_MANAGER, WidgetPlacementManager, } from './WidgetPlacementManager';
import { useOverlay } from './ScreenStateProvider';
export const WidgetsContext = React.createContext([
    [],
    EMPTY_WIDGET_PLACEMENT_MANAGER,
]);
export function useWidgets() {
    const context = React.useContext(WidgetsContext);
    if (!context) {
        throw new Error('useWidgets must be used within a WidgetProvider');
    }
    return context;
}
export function WidgetProvider(props) {
    const overlay = useOverlay();
    const widgetDefinitions = useWidgetRegister();
    const [widgets, setWidgets] = React.useState([]);
    const widgetPlacementManager = React.useMemo(() => new WidgetPlacementManager(widgets, setWidgets, overlay.setOverlay), [widgets, overlay]);
    React.useEffect(() => {
        WidgetPlacementManager.loadWidgetPlacements(widgetDefinitions);
        setWidgets(widgetDefinitions);
    }, [widgetDefinitions]);
    return (_jsx(WidgetsContext.Provider, { value: [widgets, widgetPlacementManager], children: props.children }));
}
